<!--
  The diff lines a review thread was written on (the tail of GitHub's
  `diffHunk`, see logic/reviewComments `hunkTail`), shown above the thread
  wherever a thread is read away from the diff: inside a review in the
  Overview, and in the Review view's conversation.
-->
<script lang="ts">
  import type { HunkRow } from '../logic/reviewComments';

  interface Props {
    rows: readonly HunkRow[];
    /** Where the lines are (`path:line`), for the group's name. */
    place: string;
  }
  let { rows, place }: Props = $props();
</script>

{#if rows.length}
  <div class="rv-hunk mono" role="group" aria-label="Diff lines at {place}">
    {#each rows as r, k (k)}
      <div class="rv-row {r.kind}">
        <span class="rv-ln" aria-hidden="true">{r.kind === 'del' ? r.old : r.new}</span>
        <span class="rv-sign" aria-hidden="true">{r.kind === 'add' ? '+' : r.kind === 'del' ? '−' : ' '}</span>
        <span class="rv-code">{r.text || ' '}</span>
      </div>
    {/each}
  </div>
{/if}

<style>
  .rv-hunk {
    margin: 8px 0;
    border: 1px solid var(--line);
    border-radius: 6px;
    overflow-x: auto;
    font-size: 12px;
    line-height: 1.5;
    background: var(--surface);
  }
  .rv-row {
    display: grid;
    grid-template-columns: 3.5em 1.5em max-content;
    min-width: 100%;
    width: max-content;
  }
  .rv-row.add {
    background: var(--diff-add);
  }
  .rv-row.del {
    background: var(--diff-del);
  }
  .rv-ln {
    text-align: right;
    padding-right: 6px;
    color: var(--gutter);
    user-select: none;
  }
  .rv-sign {
    text-align: center;
    color: var(--muted);
    user-select: none;
  }
  .rv-code {
    white-space: pre;
    padding-right: 10px;
  }
</style>
